import type { HeaderSubmenu } from '@/src/domains/header/components/Header/Header.types'
import { HeaderSubNavigation } from '@/src/domains/header/components/Header/HeaderSubNavigation'

export interface HeaderDesktopNavigationSubmenusProps {
  menus: HeaderSubmenu[]
  renderMenu?: (menu: HeaderSubmenu, defaultMenu: React.ReactNode) => React.ReactNode
}

export const HeaderDesktopNavigationSubmenus = ({ menus, renderMenu }: HeaderDesktopNavigationSubmenusProps) => {
  return (
    <div className="m-0 flex flex-col items-start gap-6 p-0 laptop:flex-row laptop:gap-8">
      {menus.map((menu) => {
        const defaultMenu = (
          <HeaderSubNavigation title={menu.title} items={menu.items} iconColor="primary" type={menu.type} />
        )
        return (
          <div className="flex flex-1 flex-col gap-6" key={menu.id}>
            {renderMenu?.(menu, defaultMenu) ?? defaultMenu}
          </div>
        )
      })}
    </div>
  )
}
